<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'
import { bookParams } from '@/composables/tracks/bookParameters'
import { superstoryTrack } from '@/track'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  titleClass?: string
  actionClass?: string
  gridClass?: string
  itemClass?: string
  coverClass?: string
  bookTitleClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
  gotoCollection: (id: string) => void
}>()

// 可选样式：不传时完全等价于改造前的写死类名
const GRID_CLASS_DEFAULT = 'mt-2 grid grid-cols-4 gap-2'
const ITEM_CLASS_DEFAULT = 'mt-4'
const COVER_CLASS_DEFAULT = 'rounded-8px'
const BOOK_TITLE_CLASS_DEFAULT = 'mt-10px text-14px text-n-text-1 calculate-width-3 line-clamp-2'

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :column-id="module.id"
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    :title-class="titleClass"
    :action-class="actionClass"
    @action="handleSeeAll"
  >
    <div :class="gridClass || GRID_CLASS_DEFAULT">
      <div v-for="(item, index) in module.resourceList.records.slice(0, 8)" :key="item.id">
        <div
          :class="itemClass === undefined ? ITEM_CLASS_DEFAULT : itemClass" @click="superstoryTrack('column_ck', bookParams({
            ...item,
            pos: index + 1,
            module_id: module.id,
            module_name: module.showName,
          })); gotoBook(item.id, item.firstChapter?.id)"
        >
          <BizBookCover
            :id="uuid()"
            :corner-mark-text="module.cornerMarkText"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: module.showName,
              module_id: module.id,
              module_type: module.columnType,
              author: item.authorInfo.author,
              ...item,
              pos: index + 1,
            }"
            :class="coverClass || COVER_CLASS_DEFAULT"
          />
          <p :class="bookTitleClass || BOOK_TITLE_CLASS_DEFAULT">
            {{ item.contentName }}
          </p>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>

<style lang="scss" scoped>
.calculate-width-3 {
  width: calc((100vw - 60px) / 4 - 5px);
}
</style>
